//export const serverHost = "https://localhost/dynamic";
export const serverHost = "/dynamic";